const TOC_SCROLL_OFFSET = 200;

function scrollToTableOfContentTarget(event)
{
    const id = decodeURIComponent(event.currentTarget.hash.slice(1));
    const target = document.getElementById(id);

    if (!target) {
        return;
    }

    event.preventDefault();

    const top = target.getBoundingClientRect().top + window.scrollY - TOC_SCROLL_OFFSET;

    window.scrollTo({ top, behavior: 'smooth' });
    history.pushState(null, '', '#' + id);
}

function toggleTableOfContent(event)
{
    const toggle = event.currentTarget;
    const toc = toggle.closest('.table-of-content');
    const expanded = toc.classList.toggle('is-expanded');

    toggle.setAttribute('aria-expanded', String(expanded));

    if (expanded) {
        toggle.textContent = toggle.dataset.less;
    } else {
        toggle.textContent = toggle.dataset.more;
    }
}

document.querySelectorAll('.table-of-content__toggle').forEach((toggle) => {
    toggle.addEventListener('click', toggleTableOfContent);
});

document.querySelectorAll('.table-of-content__link').forEach((link) => {
    link.addEventListener('click', scrollToTableOfContentTarget);
});
